/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useEffect, useState } from 'react'
import GradientButton from '../MUICustomButton/GradientButton'
import CustomDataTable from '../CustomDataTable/CustomDataTable'
import type { TableColumn } from 'react-data-table-component';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { deactivateRole, deleteRole, getAllRoles } from 'src/services/roleService';
import MUIModal from '../MUIModal/MUIModal';
import AddNewRole from './AddnewRole';
// @ts-ignore
import { NotificationManager } from 'react-notifications';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import OutlineButton from '../MUICustomButton/OutlineButton';
import { UPDATE_ROLE_ACTIVATE_ROLE_SUCCESS_MESSAGE, UPDATE_ROLE_ACTIVE_DEACTIVATE_SUBTITLE_1, UPDATE_ROLE_DEACTIVATE_ROLE_SUCCESS_MESSAGE, UPDATE_ROLE_DELETE_ROLE_SUCCESS_MESSAGE, UPDATE_ROLE_DELETE_SUBTITLE_2, UPDATE_USER_DELETE_SUBTITLE_1 } from 'src/constants/constant';
import UpdateRole from './UpdateRole';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MoreVerticalSolidRounded} from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import {checkEventPermission} from "../../common/utility/utility";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

interface IRolesData {
  roleId?: number | null;
  roleName: string;
  description: string;
  isDeleted: boolean;
  isActive: boolean;
  createdBy: string;
  isClientRole?: boolean;
}

interface ApiResponse {
  status: number;
  data: {
    data: IRolesData[];
    result: number;
  };
}

const ITEM_HEIGHT = 48;

const RoleList: React.FC = () => {

  const [roleListArray, setRoleListarray] = useState<IRolesData[]>([])
  const [roleSearchData, setRoleSearchData] = useState<IRolesData[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [addNewRoleModal, setAddNewRoleModal] = useState<boolean>(false);
  const [anchorActionEl, setAnchorActionEl] = useState<any>({});
  const [showDeleteRoleModal, setDeleteRoleModal] = useState<boolean>(false);
  const [roleInfoData, setRoleInfoData] = useState<any>();
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
  const [showDeactivateRoleModal, setDeactivateRoleModal] = useState<boolean>(false);
  const [selectedRoleInfo, setSelectedRoleInfo] = useState<any>(null);
  const [openUpdateRoleModal, setOpenUpdateRoleModal] = useState<boolean>(false)


  const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: any): void => {
    setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
  }

  useEffect(() => {
    getRoleData()
  }, [])


  const getRoleData = (): void => {
    setLoading(true);
    getAllRoles()
      .then((res: ApiResponse) => {
        console.log("Roles", res);
        if (res.status === 200) {
          if (res.data.result === 1) {
            // Filter out the role with roleId === 1
            const filteredRoles = res.data.data.filter((role: IRolesData) => role.roleId !== 1);
            setRoleListarray(filteredRoles);
            setRoleSearchData(filteredRoles);
          }
        }
      })
      .catch((error) => console.log("Error", error))
      .finally(() => setLoading(false));
  };
  

  const handleAddRoleClick = (): void => {
    setAddNewRoleModal(true)
  }

  const handleCloseAddRoleModal = (): void => {
    setAddNewRoleModal(false)
  }

  const handleRefreshPage = (): void => {
    setAddNewRoleModal(false)
    setOpenUpdateRoleModal(false);
    getRoleData()
  }

  const handleDeleteRole = (roleId: string, roleName: string): void => {
    setRoleInfoData({ roleId, roleName });
    setDeleteRoleModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [roleId]: null });
  }

  const handleDeleteRoleClose = ():void => {
    setDeleteRoleModal(false)
  }

  const handleDeleteRoleConfirm = ():void => {
    setIsModalSaveLoading(true)

    const { roleId } = roleInfoData;
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
    

    deleteRole(roleId, userData.id)
      .then(
        (res: ApiResponse) => {
          if(res.status === 200) {
            if(res.data.result === 1) {
              NotificationManager.success(UPDATE_ROLE_DELETE_ROLE_SUCCESS_MESSAGE, '', 5000);
              setDeleteRoleModal(false)
              getRoleData()
            }
          }
        }
      )
      .catch(error => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleDeactivateRole = (roleId: string, isActive: boolean, roleName: string): void => {
    const newIsActive = !isActive;
    setRoleInfoData({ roleId, isActive: newIsActive, roleName });
    setDeactivateRoleModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [roleId]: null });
  }

  const handleDeactivateRoleClose = ():void => {
    setDeactivateRoleModal(false)
  }

  const handleDeactivateRoleConfirm = ():void => {
    setIsModalSaveLoading(true)

    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
    const { roleId, isActive } = roleInfoData;
    

    deactivateRole(roleId, isActive, userData.id)
      .then(
        (res: ApiResponse) => {
          if(res.status === 200) {
            if(res.data.result === 1) {
              if (isActive) {
                NotificationManager.success(UPDATE_ROLE_ACTIVATE_ROLE_SUCCESS_MESSAGE, '', 5000);
              } else {
                NotificationManager.success(UPDATE_ROLE_DEACTIVATE_ROLE_SUCCESS_MESSAGE, '', 5000);
              }
              setDeactivateRoleModal(false)
              getRoleData()
            }
          }
        }
      )
      .catch(error => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleUpdateRole = (roleId: string, roleName: string, description: string, isClientRole: boolean): void => {
    setSelectedRoleInfo({ roleId, roleName, description, isClientRole });
    setOpenUpdateRoleModal(true);
    // Store roleId in session storage
    sessionStorage.setItem('roleId', roleId);
  };

  const handleCloseUpdateRoleModal = (): void => {
    setOpenUpdateRoleModal(false);
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    let roleDataArr = roleListArray
    if (value !== "") {
      roleDataArr = roleSearchData.filter((role: IRolesData) => {
        return role.roleName.toLowerCase().search(value.toLowerCase()) >= 0
      })
    }
    setRoleSearchData(roleDataArr)
  }

  const columns: TableColumn<IRolesData>[] = [
    {
      name: 'Role Name',
      selector: (row: IRolesData) => row.roleName,
      cell: (row: IRolesData) => {
        return (
          <div className='flex py-4 first:pt-0 last:pb-0'>
            <div className="overflow-hidden">
              <p className="text-14 text-muted">{row.roleName}</p>
            </div>
          </div>
        )
      },
      width: '20%',
      sortable: true
    },
    {
      name: 'Description',
      sortable: true,
      // selector: row => row.year,
      width: '25%',
      cell: (row: IRolesData) => <span>{row.description}</span>
    },
    {
      name: 'Client Role',
      sortable: true,
      width: '20%',
      cell: (row: IRolesData) => <span>{row.isClientRole ? 'Yes' : 'No'}</span>
    },
    {
      name: 'Status',
      sortable: true,
      width: "15%",
      // selector: row => row.year,
      cell: (row: IRolesData) => {
        return row.isActive ? <div className="badge truncate" style={{
          background: '#CCFFEA',
          padding: '10px 15px',
          color: '#06A864',
          border: '0px'
        }}>Active</div> : (
          <div className="badge truncate" style={{
            background: '#FFF5F6',
            padding: '10px 15px',
            color: '#F13139',
            border: '0px'
          }}>Inactive</div>
        );
      }
    },
    {
      name: 'Actions',
      sortable: false,
      width: "15%",
      id: 'actions',
      style: {
        display: 'flex',
        justifyContent: 'flex-end'
      },
      // selector: row => row.year,
      cell: (row: IRolesData) => {
        return (
          <div className='flex'>
            {/* @ts-ignore */}
            <button className="icon-hover-container" onClick={() => handleUpdateRole(row.roleId, row.roleName, row.description, row.isClientRole)}>
              <img src={'/assets/images/icons/EditIcon.svg'} alt="" />
            </button>
            {(checkEventPermission("ROLES_ACTIVATE") || checkEventPermission("ROLES_DELETE") ) && 
            <div className='flex'>
              <IconButton
                aria-label="more"
                id="long-button"
                // aria-controls={open ? 'long-menu' : undefined}
                // aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={(e) => handleActionClick(e, row.roleId)}
              >
                 <HugeiconsIcon
                                              icon={MoreVerticalSolidRounded}
                                              size={24}
                                              color="#77869E"
                                              strokeWidth={0.5}
                                            />
											
              </IconButton>
              <Menu
                id="long-menu"
                className='table-action-menu'
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                //@ts-ignore
                anchorEl={anchorActionEl[row.roleId]}
                //@ts-ignore
                open={Boolean(anchorActionEl[row.roleId])}
                //@ts-ignore
                onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.roleId]: null })}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '16ch',
                  },
                }}
              >
                 {checkEventPermission("ROLES_ACTIVATE") && 
                 // @ts-ignore
                <MenuItem onClick={() => handleDeactivateRole(row.roleId, row.isActive, row.roleName)}>
                  <span style={{ paddingLeft: '15px' }} className='text-muted font-normal'>{row.isActive ? "Deactivate" : "Activate"}</span>
                </MenuItem>
              }
                 {checkEventPermission("ROLES_DELETE") && 
                // @ts-ignore
                <MenuItem onClick={() => handleDeleteRole(row.roleId, row.roleName)}>
                 <span style={{ paddingLeft: '15px', color: '#F13139' }} className='font-normal'>Delete role</span>
                </MenuItem>
              }
              </Menu>
            </div>
      }
          </div>
        )
      }
    },
  ];

  return (
    <>
      <h2 className="text-2xl font-semibold text-title">Manage Roles</h2>
      <div className="flex my-5 gap-x-2 justify-between items-center">
        <div className="basis-3/5">
          <div className="form-control">
            <input type="text" placeholder="Search by role" className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full" onChange={handleSearch}/>
          </div>
        </div>
        <div className="basis-2/5 justify-end flex">
 {checkEventPermission("ROLES_ADD") && 
          <GradientButton color='red' onClick={handleAddRoleClick}>
            <span style={{
              width: "20px",
              height: "20px",
              background: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50px",
              marginRight: "5px"
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
              </svg>
            </span>
            Add New Role
          </GradientButton>
          }
        </div>
      </div>
      <div className='data-table-container mb-10 role-list-table'>
        <CustomDataTable
          columns={columns}
          data={roleSearchData}
          progressPending={loading}
          pagination
          // selectableRows
        />
      </div>

      <BootstrapDialog
        onClose={handleDeleteRoleClose}
        aria-labelledby="customized-dialog-title"
        open={showDeleteRoleModal}
        PaperProps={{
          sx: {
            width: '550px',
            height: '200px'
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          Delete Role
        </DialogTitle>
        {/* @ts-ignore */}
        <IconButton
          aria-label="close"
          onClick={handleDeleteRoleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <HugeiconsIcon
                                     icon={MultiplicationSignStrokeStandard}
                                     size={24}
                                     color="currentcolor"
                                     strokeWidth={0.5}
                                   /> 
        </IconButton>
        <DialogContent>
          <p className='text-14 text-muted'>{UPDATE_USER_DELETE_SUBTITLE_1} <span className='font-semibold'>{roleInfoData?.roleName}</span> {UPDATE_ROLE_DELETE_SUBTITLE_2}</p>
        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>

          <OutlineButton color='gray' onClick={handleDeleteRoleClose} width='100px'>Cancel</OutlineButton>

          <GradientButton type='button' color='red' onClick={handleDeleteRoleConfirm} width='100px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleDeactivateRoleClose}
        aria-labelledby="customized-dialog-title"
        open={showDeactivateRoleModal}
        PaperProps={{
          sx: {
            width: '550px',
            height: '200px'
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          {roleInfoData?.isActive ? "Activate Role" : "Deactivate Role"}
        </DialogTitle>
        {/* @ts-ignore */}
        <IconButton
          aria-label="close"
          onClick={handleDeactivateRoleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
           <HugeiconsIcon
                                     icon={MultiplicationSignStrokeStandard}
                                     size={24}
                                     color="currentcolor"
                                     strokeWidth={0.5}
                                   /> 
        </IconButton>
        <DialogContent>
          <p className='text-14 text-muted'>{UPDATE_ROLE_ACTIVE_DEACTIVATE_SUBTITLE_1} {roleInfoData?.isActive ? "activate" : "deactivate"} <span className='font-semibold'>{roleInfoData?.roleName}</span> {UPDATE_ROLE_DELETE_SUBTITLE_2}</p>
        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>

          <OutlineButton color='gray' onClick={handleDeactivateRoleClose} width='130px'>Cancel</OutlineButton>

          <GradientButton type='button' color='red' onClick={handleDeactivateRoleConfirm} width='130px'>{!isModalSaveLoading ? roleInfoData?.isActive ? "Activate" : "Deactivate" : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
        </DialogActions>
      </BootstrapDialog>

      <MUIModal title='Add Role' openModal={addNewRoleModal} closeModal={handleCloseAddRoleModal} width={'50%'}>
        <AddNewRole refreshPage={handleRefreshPage} closeModal={handleCloseAddRoleModal} />
      </MUIModal>

      <MUIModal title='Edit Role' openModal={openUpdateRoleModal} closeModal={handleCloseUpdateRoleModal} width={'50%'}>
        <UpdateRole selectedRoleInfo={selectedRoleInfo} closeModal={handleCloseUpdateRoleModal} refreshPage={handleRefreshPage}/>
      </MUIModal>
    </>
  )
}

export default RoleList